import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@/App";
import { buildQS, getAttachement } from "@components/Utils";

export function SpinnerButton({ children, isLoading, disabled, href, name, tooltip = "", tooltip_hide = 0, ...other }) {
    const { apiIsLoading } = useAppContext();

    let btn = "";
    if (href) {
        let cls = other.className || "";
        cls += " btn";
        cls += " btn-" + other.variant;
        if (other.size) {
            cls += " btn-" + other.size;
        }
        const newOther = { ...other };
        delete newOther.className;
        delete newOther.size;
        btn = (
            <a href={href} className={cls} {...newOther}>
                {children}
            </a>
        );
    } else {
        if (!name) {
            return <div style={{ color: "red" }}>Button without name</div>;
        }

        const nameLoading = name + (other.value ? "-" + other.value : "");
        const newOther = { ...other };
        if (newOther.innerRef) {
            newOther.ref = newOther.innerRef;
            delete newOther.innerRef;
        }

        isLoading ||= apiIsLoading;

        btn = (
            <Button name={name} {...newOther} disabled={disabled || isLoading}>
                {isLoading === nameLoading ? (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                ) : (
                    children
                )}
            </Button>
        );
    }

    if (tooltip) {
        return (
            <OverlayTrigger
                placement={String(tooltip).length > 150 ? "auto" : "top"}
                overlay={<Tooltip className="show-wrap-text">{tooltip}</Tooltip>}
                delay={{ hide: tooltip_hide }}
            >
                {btn}
            </OverlayTrigger>
        );
    }

    return btn;
}

export function ExportButton({ children, apiUrl, buildReport, prms, buttonText, ...other }) {
    const { t } = useTranslation();
    const { apiUrl: appApiUrl, apiIsLoading, setApiIsLoading } = useAppContext();

    apiUrl ||= appApiUrl;

    prms ||= {};
    prms.build_report = "build_report";
    if (buildReport) {
        prms.build_report = buildReport;
    }

    return (
        <SpinnerButton
            {...other}
            isLoading={apiIsLoading}
            variant="success"
            name={prms.build_report}
            onClick={() => {
                setApiIsLoading(prms.build_report);
                getAttachement(apiUrl + "?" + buildQS(prms), {
                    finally: () => setApiIsLoading(false),
                });
            }}
        >
            {children || <>{buttonText || t("Выгрузить")}</>}
        </SpinnerButton>
    );
}
